export const isRouteAllowed = (
  pathname: string,
  allowedPaths: string[],
): boolean => {
  if (!allowedPaths || !allowedPaths.length) return false;

  const cleanPath = pathname.replace(/\/+$/, '') || '/';

  return allowedPaths.some(allowed => {
    if (!allowed) return false;
    const cleanAllowed = allowed.replace(/\/+$/, '') || '/';
    if (cleanAllowed === cleanPath) return true;
    if (cleanPath.startsWith(`${cleanAllowed}/`)) return true;
    return false;
  });
};

export default isRouteAllowed;
